
import { Component, Vue } from 'vue-property-decorator'
import RacingResultService from '@/biz/service/Racing/RacingResultService'
import RacingGroupService from '@/biz/service/Racing/RacingGroupService'
import { arrayChunk } from '@/service/ToolsService'
import RacingService from '@/biz/service/Racing/RacingService'
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import print from 'vue-print-nb'
import ConstService from '@/service/ConstService'

@Component({
  directives: {
    print
  }
})
export default class ViewRacingPrintGeneralPrize extends Vue {
  private RacingService = RacingService
  private RacingGroupService = RacingGroupService
  private list = [] as any[][]

  private handleLoad () {
    return RacingResultService.printTotalResultTable({ isPrize: 1 })
      .then((res) => {
        res.data = res.data.map((item: any) => {
          item._display_name = `${item.real_name}(${ConstService.getNationalityOptionsLabel(item.nationality)}) / ${item.pilot_real_name}(${ConstService.getNationalityOptionsLabel(item.pilot_nationality)})`
          return item
        })
        this.list = arrayChunk(res.data, 22)
      })
  }

  private handleTableLoad (index: number) {
    return Promise.resolve(this.list[index])
  }
}
